import * as jwt_decode from 'jwt-decode';
import * as _ from 'lodash';

const ICON_SRC = '/assets/img/icons/png/';

export function resolveIcon(contentType) {
    switch (contentType) {

        case 'image/png': {
            return ICON_SRC + 'png.png';
        }

        case 'image/jpeg': {
            return ICON_SRC + 'jpg.png';
        }

        case 'application/pdf': {
            return ICON_SRC + 'pdf.png';
        }

        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
            return ICON_SRC + 'doc.png';
        }

        case 'application/msword': {
            return ICON_SRC + 'doc.png';
        }

        case 'application/vnd.oasis.opendocument.presentation': {
            return ICON_SRC + 'ppt.png'
        }

        default: {
            return ICON_SRC + 'file.png';
        }

    }
}

export function decodeToken(token) {
    try {
        return jwt_decode(token);
    }
    catch (Error) {
        return null;
    }
}
export function toQueryString(obj) {
    return _.map(obj, (value, key) => key + '=' + value ).join('&')
}
